import { getFieldOnMainLanguage } from '@app/utils/languages';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface TreeNodeProps {
  isOpen?: boolean;
  taxonomy: GenericObject;
  orderable?: boolean;
  handleToggle?(item: GenericObject | null): void;
  handleClickItem?(item: GenericObject): void;
}

export const TreeNode = ({ isOpen, orderable, taxonomy, handleToggle, handleClickItem }: TreeNodeProps) => {
  return (
    <div
      onClick={() => !!(!orderable && handleClickItem) && handleClickItem(taxonomy)}
      aria-hidden="true"
      style={{ padding: 10, display: 'flex', cursor: 'pointer', alignItems: 'center' }}>
      {!orderable && (
        <div
          data-cy="taxonomy-toggle"
          onClick={() => handleToggle && handleToggle(taxonomy)}
          aria-hidden="true"
          style={{ marginLeft: 10 }}>
          {isOpen ? <ExpandMoreIcon /> : <ChevronRightIcon />}
        </div>
      )}
      {orderable && (
        <div style={{ marginLeft: 10 }}>
          <DragHandleIcon />
        </div>
      )}
      <div
        onClick={() => !!(!orderable && handleToggle) && handleToggle(taxonomy)}
        aria-hidden="true"
        style={{ marginLeft: 10 }}>
        {isOpen ? <FolderOpenIcon /> : <FolderIcon />}
      </div>
      <div data-cy="taxonomy-name" style={{ marginLeft: 10 }}>
        {getFieldOnMainLanguage(taxonomy?.category_name)}
      </div>
    </div>
  );
};
